import { ExclamationCircleFilled } from '@ant-design/icons';
import type { ReactNode } from 'react';
import styles from './InlineError.module.scss';

type Props = {
  title: string;
  detail?: ReactNode;
};

export const InlineError = ({ title, detail }: Props) => {
  return (
    <div className={styles.root} role="alert">
      <ExclamationCircleFilled className={styles.icon} />
      <div>
        <div className={styles.title}>{title}</div>
        {detail ? <div className={styles.detail}>{detail}</div> : null}
      </div>
    </div>
  );
};
